<template>
    <div class="pdf-content">
        <main>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 mt-3"><h2 class="text-center mb-0"><b>RELATÓRIO DE STATUS DAS ENTREGAS</b></h2></div>
                </div>
                <div v-for="(company, indexCompany) in report_data" :key="indexCompany">
                    <div class="row">
                        <div class="col-12 mt-3"><h5 class="text-center"><b>{{ indexCompany.toUpperCase() }}</b></h5></div>
                    </div>
                    <div v-for="(driver, indexDriver) in company" :key="indexDriver">
                        <div v-for="(cargo, indexCargo) in driver" :key="indexCargo" class="mt-3">
                            <div class="row">
                                <div class="col-4 my-2"><b>MOTORISTA:</b> {{ getDriver(cargo[0].driver_name, cargo[0].driver_document) }}</div>
                                <div class="col-4 my-2"><b>PLACA:</b> {{ getLicensePlate(cargo[0].license_plate) }}</div>
                                <div class="col-4 my-2"><b>CARGA:</b> {{ getCargo(cargo[0].cargo) }}</div>
                                <div class="col-4 my-2"><b>DATA DE ENTREGA:</b> {{ getDate(cargo[0].date) }}</div>
                                <div class="col-4 my-2"><b>INÍCIO DA VIAGEM:</b> {{ getDeliveryStart(cargo[0].cargo_start, cargo[0].delivery_start) }}</div>
                                <div class="col-4 my-2"><b>KM PERCORRIDOS:</b> 
                                    <ReportCalcTotalDistance 
                                        :fk_driver="cargo[0].fk_driver"
                                        :driver_document="cargo[0].driver_document"
                                        :license_plate="cargo[0].license_plate"
                                        :delivery_start="cargo[0].delivery_start"
                                        :cargo="cargo[0].cargo"
                                        :start_date="fields.start_date"
                                        :end_date="fields.end_date"
                                        :show_cargo="fields.show_cargo"

                                        ref="total_distance"
                                        @calculated="verifyCalcDistance"
                                    />
                                </div>
                            </div>
                            <div class="col-12"><div class="text-center mt-3 p-2 bg-light"><b>ENTREGAS</b></div></div>
                            <div class="col-12 mb-5">
                                <table class="table table-striped">
                                    <thead class="table-bordered">
                                        <tr>
                                            <th>SEQ.</th>
                                            <th>STATUS</th>
                                            <th>TIPO</th>
                                            <th>NÚMERO</th>
                                            <th>CLIENTE</th>
                                            <th>REENTREGA</th>
                                            <th>INÍCIO</th>
                                            <th>CHECK-IN</th>
                                            <th>DIST. CLIENTE/CHECK-IN</th>
                                            <th>FIM</th>
                                            <th>DIST. CLIENTE/FIM</th>
                                            <th>TEMPO VIAGEM</th>
                                            <th>OBS.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(delivery, indexDelivery) in cargo" :key="indexDelivery">
                                            <td>{{ (indexDelivery + 1) }}</td>
                                            <td>{{ getStatus(delivery.status) }}</td>
                                            <td>{{ getType(delivery.type) }}</td>
                                            <td>{{ delivery.document_number }}</td>
                                            <td>{{ delivery.customer_name }}</td>
                                            <td>{{ getRestart(delivery.status, delivery.delivery_pause, delivery.delivery_restart) }}</td>
                                            <td>{{ delivery.status != "waiting" ? getDateTime(delivery.delivery_restart ? delivery.delivery_restart : delivery.delivery_start) : "" }}</td>
                                            <td><span :style="verifyCheckinDate(delivery.checkin_date, delivery.status) ? 'color:red; font-weight:bold;' : ''">{{ getCheckinDate(delivery.checkin_date, delivery.status) }}</span></td>
                                            <td>{{ getDistance(delivery.checkin_location, delivery.customer_location) }}</td>
                                            <td>{{ getDateTime(delivery.delivery_end) }}</td>
                                            <td>{{ getDistance(delivery.delivery_end_location, delivery.customer_location) }}</td>
                                            <td><span :style="verifyTotalTime(delivery.delivery_start, delivery.delivery_end) ? 'color:red; font-weight:bold;' : ''">{{ getTotalTime(delivery.delivery_start, delivery.delivery_end) }}</span></td>
                                            <td>{{ delivery.delivery_info }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-12">
                                <p class="text-center mb-0"><small><b>Gerado em {{ getCurrentDateTime() }}</b></small></p>
                                <p class="text-center mb-0"><a class="link-dark text-decoration-none" :href="root_url_painel" target="_blank"><small>DeliveryB2B.com.br</small></a></p>
                            </div>
                            <div class="html2pdf__page-break"></div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import ReportCalcTotalDistance from './ReportCalcTotalDistance.vue';

const status = {
    waiting: "Aguardando",
    in_progress: "A caminho",
    finished: "Finalizado",
    failed: "Não entregue",
};

const type = {
    0: "N",
    1: "P",
};

export default {
    name: "ReportPdfContent",

    components: {
        ReportCalcTotalDistance,
    },
    
    props: {
        data: {
            type: Object,
            require: true,
        },
        fields: {
            type: Object,
            require: true,
        },
    },

    data: function() {
        return {
            root_url_painel: this.$api.config.B2B_ROOT_URL_PAINEL,
            report_data: this.data,
            total_distance: [],
        }
    },
    
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => { this.$emit("domRendered"); }, 1000);
        });
    },

    methods: {
        getDriver: function(name, document) {
            if (name && document) return name.toUpperCase() + " - " + this.getDocument(document);
            else return "Não definido";
        },

        getDocument: function(value) {
            if (value) {
                if (value > 11) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
                else return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            }
            else return "";
        },

        getLicensePlate: function(license_plate) {
            if (license_plate) return license_plate;
            return "Não definido";
        },
        
        getCargo: function(cargo) {
            if (cargo) return cargo;
            return "Não definida";
        },

        getDate: function(value) {
            if (value) return value.split("-").reverse().join("/");
            else return "";
        },

        getDateTime: function(value) {
            if (value) {
                let aux = value.split(" ");
                return this.getDate(aux[0]) + " " + aux[1];
            }
            else return "";
        },

        getDeliveryStart: function(cargo_start, delivery_start) {
            return this.getDateTime(cargo_start ? cargo_start : delivery_start);
        },

        getStatus: function(value) {
            return status[value];
        },
        
        getType: function(value) {
            return type[value];
        },

        verifyCheckinDate: function(checkin_date, status) {
            if (["in_progress", "finished", "failed"].includes(status)) {
                if (checkin_date) return false;
                else return true;
            } else {
                return false;
            }
        },

        getCheckinDate: function(checkin_date, status) {
            if (["in_progress", "finished", "failed"].includes(status)) {
                if (checkin_date) return this.getDateTime(checkin_date);
                else return "NÃO REALIZADO";
            } else {
                this.getDateTime(checkin_date);
            }
        },

        verifyTotalTime: function(delivery_start, delivery_end) {
            if (delivery_start && delivery_end) {
                let start = new Date(delivery_start);
                let end = new Date(delivery_end);

                let diff = end.getTime() - start.getTime();
                
                if (diff < 120000) return true;
                else return false;
            } else return false;
        },

        getTotalTime: function(delivery_start, delivery_end) {
            if (delivery_start && delivery_end) {
                let start = new Date(delivery_start);
                let end = new Date(delivery_end);

                let diff = end.getTime() - start.getTime();
                
                let msec = diff;
                let hh = Math.floor(msec / 1000 / 60 / 60);
                msec -= hh * 1000 * 60 * 60;
                let mm = Math.floor(msec / 1000 / 60);
                msec -= mm * 1000 * 60;
                let ss = Math.floor(msec / 1000);
                msec -= ss * 1000;

                return this.formattedNumber(hh) + ":" + this.formattedNumber(mm) + ":" + this.formattedNumber(ss);
            } else {
                return "";
            }
        },

        // Calcula a longitude e latitude de dois pontos e retorna a distânca em km
		calcDistance: function(positionFrom, positionTo) {
			const R = 6371; // km
			let dLat = this.toRad(positionTo.lat - positionFrom.lat);
			let dLng = this.toRad(positionTo.lng - positionFrom.lng);
			let latFrom = this.toRad(positionFrom.lat);
			let latTo = this.toRad(positionTo.lat);

			let a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLng/2) * Math.sin(dLng/2) * Math.cos(latFrom) * Math.cos(latTo); 
			let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
			let d = R * c;
			return d;
		},

        // Converte grau para radiano
		toRad: function(value) 
		{
			return value * Math.PI / 180;
		},

        getDistance: function(from, to) {
            if (from && to) {
                let positionFrom = {
                    lat: from.split(",")[0],
                    lng: from.split(",")[1],
                };

                let positionTo = {
                    lat: to.split(",")[0],
                    lng: to.split(",")[1],
                };

                let distance = this.calcDistance(positionFrom, positionTo);
                return this.getDistanceFormatted(distance);
            } else return "";
        },

        getDistanceFormatted: function(distance) {
            return distance.toFixed(1).replace(".", ",") + " km";
        },

        getRestart: function(status, pause, restart) {
            if (["in_progress", "finished", "failed"].includes(status)) {
                if (pause || restart) return "SIM";
                else return "NÃO";
            } else {
                return "";
            }
        },

        getCurrentDateTime: function() {
            let date_time = new Date();
            
            let date = this.formattedNumber(date_time.getDate());
            let month = this.formattedNumber(date_time.getMonth() + 1);
            let hours = this.formattedNumber(date_time.getHours());
            let minutes = this.formattedNumber(date_time.getMinutes());
            
            return date + "/" + month + "/" + date_time.getFullYear() + " às " + hours + ":" + minutes;
        },

        formattedNumber: function(value) {
            return value < 10 ? "0" + value : value;
        },

        verifyCalcDistance: function() {
            let download = true;
            this.$refs.total_distance.forEach(element => {
                if (element.loading) download = false;
            });
            this.$emit("download", download);
        },
    },
}
</script>

<style scoped src="../../../node_modules/bootstrap/dist/css/bootstrap.css">
</style>